export function generateDefaultUserInput(userInput, theme) {
    const userInputOutput = {};
    for (const { id, required, placeholder, defaultValue, parentId, } of theme.userInputFields || []) {
        let value = userInput?.[id];
        // Required values should always show a value, even if the user
        // input value is blank.
        if (!value && required && (defaultValue || placeholder)) {
            value = defaultValue || placeholder;
        }
        // Non-required values should only show the default value if the
        // user input value has not been set at all.
        if (typeof value === "undefined" && (defaultValue || placeholder)) {
            // If the user has edited the parent field, using a default
            // or placeholder value no longer makes sense for this dependent
            // field. So we check for that first, before populating.
            if (!parentId || !userInput?.[parentId]) {
                value = defaultValue || placeholder;
            }
        }
        if (id === "date" && !userInput?.[id] && !defaultValue) {
            userInputOutput[id] = new Date().toISOString();
        }
        else if (value) {
            userInputOutput[id] = value;
        }
    }
    return userInputOutput;
}
